import { Howler } from 'howler';

export const unlockAudioContext = () => {
  if (typeof Howler !== 'undefined' && Howler.ctx?.state === 'suspended') {
    Howler.ctx.resume().catch((err) => {
      console.warn('Failed to resume AudioContext:', err);
    });
  }
};